import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { theme, media } from 'styles';
import { IconPlus, IconMinus } from 'icons';

const propTypes = {
  quantity: PropTypes.number.isRequired,
  quantityVariable: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

const StyledQuantitySelector = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-around;
  border: 1px solid ${theme.colors.border};
  border-radius: 4px;
  height: 51px;
  width: 200px;
  background: ${theme.colors.white};
  color: ${theme.colors.royal};
  ${media.tablet`margin-right: 20px`};
  margin-right: 20px;
`;

const StyledCurrentQuantity = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  width: 30px;
  height: 100%;
  text-align: center;
  font-weight: 400;
  font-size: 24px;
  line-height: 28px;
`;

const StyledQuantityName = styled.div`
  font-size: 12px;
  line-height: 12px;
  margin-bottom: 4px;
`;

const StyledChangeQuantity = styled.button`
  flex: 1 1;
  text-align: center;
  color: ${theme.colors.grey};
  font-weight: 300;
  font-size: 48px;

  > span {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
`;

function QuantitySelector({ quantity, quantityVariable, onChange }) {
  return (
    <StyledQuantitySelector>
      <StyledChangeQuantity
        onClick={() => onChange(-1)}
        disabled={quantity < 2}
      >
        <span>
          <IconMinus />
        </span>
      </StyledChangeQuantity>

      <StyledCurrentQuantity>
        <div>{quantity}</div>
        <StyledQuantityName>{quantityVariable}</StyledQuantityName>
      </StyledCurrentQuantity>

      <StyledChangeQuantity onClick={() => onChange(1)}>
        <span>
          <IconPlus />
        </span>
      </StyledChangeQuantity>
    </StyledQuantitySelector>
  );
}

QuantitySelector.propTypes = propTypes;

export default QuantitySelector;



// WEBPACK FOOTER //
// ./src/components/shared/AddToCart/QuantitySelector.jsx